import { Injectable, computed, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BlockingWaitFacade {
  private readonly _activeCount = signal(0);

  readonly busy = computed(() => this._activeCount() > 0);

  begin(): void {
    this._activeCount.update((count) => count + 1);
  }

  end(): void {
    this._activeCount.update((count) => Math.max(0, count - 1));
  }
}
